import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export enum FancyDotPosition {
    TOP = 'top-align',
    BOTTOM = 'bottom-align',
}

interface Props {
    hidden?: boolean;
    title: string;
    dotText: string;
    dotPosition: FancyDotPosition;

    children: ReactNode;
}

function TimelineBox(props: Props) {
    if (props.hidden) {
        return <div>{props.children}</div>;
    }

    const alignClass = props.dotPosition;

    return (
        <div className={'timeline-box'}>
            <div className={'top-text'}>
                <h3>{props.title}</h3>
            </div>
            <div className={`dot-holder ${alignClass}`}>
                <FontAwesomeIcon icon={faCircle} />
            </div>
            <div className={`dot-text ${alignClass}`}>{props.dotText}</div>
            {props.children}
        </div>
    );
}

export default TimelineBox;
